import { InfoOutlined, UserOutlined } from '@ant-design/icons';
import { Space, Tooltip } from 'antd';
import { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import { LOCAL_STORAGE, ROUTES } from '../../../common/constants';
import { removeItem } from '../../../common/utils';
import { RoutePromptContext } from '../../../RoutePromptContext';
import { AppContextType } from '../../../types/appContext.type';
import '../../app.less';

const UserProfile = () => {
  const routePromptContext = useContext(RoutePromptContext);

  const {
    state: { currentUser, routerPrompt },
  } = useContext(AppContext) as AppContextType;

  const ClearLocalstorage = () => {
    removeItem(LOCAL_STORAGE.OTP_STEP);
    removeItem(LOCAL_STORAGE.CURRENT_PHONE);
    removeItem(LOCAL_STORAGE.OTP_START_TIME);
  };
  if (!routePromptContext) return null;
  const { handleNavigationAttempt } = routePromptContext;

  return (
    <Space className="pointer d-flex align-center profile-space" size="small">
      <div className="avatar-wrapper">
        <InfoOutlined
          className="vastu-rules-icon"
          onClick={() =>
            handleNavigationAttempt(ROUTES.VASTU_RULE, routerPrompt)
          }
        />
      </div>

      <Tooltip
        color="white"
        key={currentUser?.id}
        title={`${currentUser?.firstName} ${currentUser?.lastName}`}
        placement="bottom"
        overlayClassName="user-tooltip"
      >
        <div
          className="user-avatar-wrapper"
          onClick={() => {
            if (location.pathname !== ROUTES.PROFILE) {
              handleNavigationAttempt(ROUTES.PROFILE, routerPrompt);
            }
            ClearLocalstorage();
          }}
        >
          {currentUser?.avatar ? (
            <img
              src={currentUser?.avatar || undefined}
              className="user-profile-avatar"
            />
          ) : (
            <UserOutlined />
          )}
        </div>
      </Tooltip>
    </Space>
  );
};

export default UserProfile;
